module.exports = __webpack_public_path__ + "img/maneken_pos_5.968fd857.png";